<template>
  <div class="tour__detail">
    <div class="tour__detail-head">
      <icon :name="icon" class="detail__icon" :style="{color: color, background: backgroundColor}"></icon>
      <div class="detail__title">{{title}}</div>
    </div>
    <div class="detail__text">{{text}}</div>
  </div>
</template>

<script>
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "TourDetail",
  props: {
    color: String,
    icon: String,
    title: String,
    text: String
  },
  computed: {
    backgroundColor() {
      const color = "0x" + this.color.substring(1);
      const rgb = [(color >> 16) & 255, (color >> 8) & 255, color & 255];
      const current = 255 * 3 - rgb.reduce((acc, cur) => acc + cur, 0);
      const test = (255 - 255 * 0.92) * 3;
      return (
        "#" +
        rgb
          .map(part =>
            (255 - Math.round(((255 - part) / current) * test)).toString(16)
          )
          .join("")
      );
    }
  },
  components: {
    Icon
  }
};
</script>

<style scoped lang="scss">
.tour__detail-head {
  display: flex;
  flex-direction: row;
  margin-bottom: 4px;
}

.detail__icon {
  min-width: 48px;
  min-height: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-right: 24px;
}

.detail__title {
  line-height: 32px;
  font-family: "Playfair Display";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #0d0d0d;
  text-align: left;
}

.detail__text {
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: #4d4d4d;
  text-align: left;
  margin-left: 70px;
  line-height: 23px;
}

@media (max-width: 1023px) {
  .tour__detail-head {
    margin-bottom: 16px;
    align-items: center;
  }

  .detail__icon {
    margin-right: 16px;
  }

  .detail__text {
    margin-left: 0;
  }
}

@media (max-width: 767px) {
  .detail__icon {
    font-size: 18px;
    min-width: 32px;
    min-height: 32px;
  }
}
</style>
